module.exports = __webpack_public_path__ + "static/media/calculadora-icon.c562ed49.png";